import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

@Injectable()
export class WasteDescriptionService {
    constructor(private http: HttpClient) { }

  
    wasteDescriptionList(){
        return this.http.get(environment.apiURL + 'shared/list-waste-description').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    addWasteDescription(data){
        return this.http.post(environment.apiURL + 'shared/add-waste-description', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    updateWasteDescription(data){
        return this.http.post(environment.apiURL + 'shared/update-waste-description', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    updateVehicleType(data) {
        return this.http.post(environment.apiURL + 'shared/update-vehicle-types', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    fetchType() {
        return this.http.get(environment.apiURL + 'types/list').pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    createType(data) {
        return this.http.post(environment.apiURL + 'types/create', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    updateType(data) {
        return this.http.post(environment.apiURL + 'types/update', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
    deleteVehicleType(id) {
        let data;
            data = {_id:id};
        return this.http.post(environment.apiURL + 'shared/delete-vehicle-types', data).pipe(
            tap((response: any) => {
                return response;
            })
        );
    }
}
